export const SOCKET_ROUTES = {
  PING: 'ping',
  GRAPH_REGISTER_ID: 'graph_register_id',
  GRAPH_CHECK_STATUS: 'graph_check_status',
  GRAPH_DISCONNECT: 'graph_disconect'
}